module.exports = __webpack_public_path__ + "static/media/discord.147f41c9.svg";